/* tslint:disable:prefer-const */
/**
 * Created by bburke on 6/20/2016.
 */
import {Injectable} from '@angular/core';
import {Subscription} from 'rxjs';
import {DatePipe} from '@angular/common';

@Injectable()
export class Utils {
    static loginTimer;

    static clamp(min: number, val: number, max: number): number {
        return Math.min(Math.max(min, val), max);
    }

    static forceLogout() {
        this.loginTimer = setTimeout(function () {
            console.log('Changed');
        }, 3000);
        // 1800000
    }

    static cloneObject(obj): any {
        if (obj == null || typeof obj !== 'object') return obj;

        const temp = new obj.constructor();
        for (const key in obj) temp[key] = Utils.cloneObject(obj[key]);

        return temp;
    }

    static indexOfObject(arr: Array<any>, object: {}): number {
        const targetKeys = Object.keys(object);
        const index: number = arr.findIndex(item => {
            const keys = Object.keys(item);
            return (
                keys.length === targetKeys.length &&
                keys.every(function (key) {
                    return object.hasOwnProperty(key) && item[key] === object[key];
                })
            );
        });
        return index;
    }

    static resetLogout() {
        clearTimeout(this.loginTimer);
        this.forceLogout();
    }

    static getDate(stringDate) {
        if (stringDate) {
            return new Date(stringDate);
        }
        return stringDate;
    }

    static convertDateForDB(date) {
        return new DatePipe('en-US').transform(date, 'yyyy-MM-dd HH:mm:ss.SSSSSS');
    }

    static convertFromDBtoDateTime(date) {
        return new DatePipe('en-US').transform(date, 'M/dd/yyy HH:mm:ss a');
    }

    static convertFromDBtoDate(date) {
        return new DatePipe('en-US').transform(date, 'M/dd/yyy');
    }

    static getName(firstName, lastName) {
        let name = '';
        if (firstName && lastName) {
            name = lastName + ', ' + firstName;
            return name;
        }
        return name;
    }

    static getFullName(firstName: string, middleName: string, lastName: string) {
        let name = '';

        name += firstName + ' ';

        if (middleName) {
            name += middleName + ' ';
        }

        name += lastName;
        return name;
    }

    static getSSN(taxId: string) {
        if (taxId) {
            taxId = taxId.toString();
            return taxId.substring(0, 3) + '-' + taxId.substring(3, 5) + '-' + taxId.substring(5, 9);
        }
        return taxId;
    }

    static getPhone(homePhone) {
        if (homePhone) {
            if (typeof homePhone === 'string') {
                if (homePhone.substr(0, 1) === '0') {
                    return homePhone.substr(1, 3) + '-' + homePhone.substr(4, 4);
                }
                return '(' + homePhone.substr(0, 3) + ') ' + homePhone.substr(3, 3) + '-' + homePhone.substr(6, 4);
            }

            if (typeof homePhone === 'object') {
                const parts = [];

                if (homePhone.countryCode) {
                    parts.push('+' + homePhone.countryCode);
                }

                if (homePhone.areaCode) {
                    parts.push('(' + homePhone.areaCode + ')');
                }

                parts.push(homePhone.number.toString().substring(0, 3) + '-' + homePhone.number.toString().substring(3, 7));

                return parts.join(' ');
            }
        }

        return homePhone;
    }

    static getPhoneFromObject(phone) {
        if (phone.phoneNumber) {
            phone.number = phone.phoneNumber;
        }
        if (phone.areaCode && phone.number) {
            const area = '(' + phone.areaCode + ') ';
            const prefix = phone.number.toString().substring(0, 3) + '-';
            const suffix = phone.number.toString().substring(3, 7);
            return area + prefix + suffix;
        }

        if (phone.areaCode === 0) {
            const prefix = phone.number.toString().substring(0, 3) + '-';
            const suffix = phone.number.toString().substring(3, 7);
            return prefix + suffix;
        }
    }

    static orderBy(arr: any[], keyOrFn: string | Function, direction?: 'asc' | 'desc' | '') {
        if (Array.isArray(arr)) {
            if (typeof keyOrFn === 'string') {
                arr.sort((n1, n2) => {
                    if (n1[keyOrFn] > n2[keyOrFn]) return 1;
                    if (n1[keyOrFn] < n2[keyOrFn]) return -1;
                    return 0;
                });
            } else {
                arr.sort((n1, n2) => {
                    if (keyOrFn(n1) > keyOrFn(n2)) return 1;
                    if (keyOrFn(n1) < keyOrFn(n2)) return -1;
                    return 0;
                });
            }

            if (direction === 'desc') {
                return arr.reverse();
            }
        }
        return arr;
    }

    static orderByDate(arr: any[], keyOrFn: string | Function, direction?: 'asc' | 'desc' | '') {
        if (Array.isArray(arr)) {
            if (typeof keyOrFn === 'string') {
                arr.sort((n1, n2) => {
                    if (new Date(n1[keyOrFn]).getTime() >new Date( n2[keyOrFn]).getTime() ) return 1;
                    if (new Date(n1[keyOrFn]).getTime()  < new Date(n2[keyOrFn]).getTime() ) return -1;
                    return 0;
                });
            } else {
                arr.sort((n1, n2) => {
                    if (new Date(keyOrFn(n1)).getTime()  > new Date(keyOrFn(n2)).getTime() ) return 1;
                    if (new Date(keyOrFn(n1)).getTime()  < new Date(keyOrFn(n2)).getTime() ) return -1;
                    return 0;
                });
            }

            if (direction === 'desc') {
                return arr.reverse();
            }
        }
        return arr;
    }

    static orderArrBy(arr) {
        if (arr) {
            arr.sort((n1, n2) => {
                if (n1.value > n2.value) {
                    return 1;
                }

                if (n1.value < n2.value) {
                    return -1;
                }

                return 0;
            });
        }
        return arr;
    }

    static orderArrByCharAndNumber(arr) {
        if (arr) {
            if (typeof arr[0] === 'string') {
                arr.sort(function (a, b) {
                    if (isNaN(a) && isNaN(b)) return a < b ? -1 : a === b ? 0 : 1;
                    // both are string
                    else if (isNaN(a)) return 1;
                    // only a is a string
                    else if (isNaN(b)) return -1;
                    // only b is a string
                    else return a - b; // both are num
                });
            } else {
                arr.sort(function (a, b) {
                    if (isNaN(a.value) && isNaN(b.value)) return a.value < b.value ? -1 : a.value === b.value ? 0 : 1;
                    // both are string
                    else if (isNaN(a.value)) return 1;
                    // only a is a string
                    else if (isNaN(b.value)) return -1;
                    // only b is a string
                    else return a.value - b.value; // both are num
                });
            }
        }
        return arr;
    }

    static orderArrBySfx(sfx) {
        if (sfx) {
            sfx.sort((n1, n2) => {
                if (n1.sfx > n2.sfx) {
                    return 1;
                }

                if (n1.sfx < n2.sfx) {
                    return -1;
                }

                return 0;
            });
        }
        return sfx;
    }

    static orderByAccountNumber(acct) {
        if (acct) {
            acct.sort((n1, n2) => {
                if (n1.accountNumber > n2.accountNumber) {
                    return 1;
                }

                if (n1.accountNumber < n2.accountNumber) {
                    return -1;
                }

                return 0;
            });
        }
        return acct;
    }

    // sort array by case insensitive string value, optionally by key or function
    static orderAlpha(arr: any[], keyOrFn?: string | Function, direction?: 'asc' | 'desc') {
        if (Array.isArray(arr)) {
            if (keyOrFn === undefined) {
                arr.sort((a, b) => {
                    if (
                        String(a)
                            .toLowerCase()
                            .trim() >
                        String(b)
                            .toLowerCase()
                            .trim()
                    )
                        return 1;
                    if (
                        String(a)
                            .toLowerCase()
                            .trim() <
                        String(b)
                            .toLowerCase()
                            .trim()
                    )
                        return -1;
                    return 0;
                });
            } else if (typeof keyOrFn === 'function') {
                arr.sort((a, b) => {
                    const aVal = String(keyOrFn(a))
                        .toLowerCase()
                        .trim();
                    const bVal = String(keyOrFn(b))
                        .toLowerCase()
                        .trim();

                    if (aVal > bVal) return 1;
                    if (aVal < bVal) return -1;
                    return 0;
                });
            } else if (typeof keyOrFn === 'string') {
                arr.sort((a, b) => {
                    if (
                        String(a[keyOrFn])
                            .toLowerCase()
                            .trim() >
                        String(b[keyOrFn])
                            .toLowerCase()
                            .trim()
                    )
                        return 1;
                    if (
                        String(a[keyOrFn])
                            .toLowerCase()
                            .trim() <
                        String(b[keyOrFn])
                            .toLowerCase()
                            .trim()
                    )
                        return -1;
                    return 0;
                });
            }

            if (direction === 'desc') {
                arr.reverse();
            }
        }
        return arr;
    }

    static formatDollar(num: any): string {
        num = this.parseFloatRobust(num);

        // typescript complains but passing these parameters is supported:
        return num.toLocaleString('en-US', {style: 'currency', currency: 'USD'});
    }

    static parseFloatRobust(num: any) {
        if (typeof num === 'number' && !Number.isNaN(num)) {
            return num;
        } else if (typeof num === 'string') {
            num = num.replace(/[^0-9.-]/g, ''); // remove everything except digits, decimal points, minus signs
            const negative = num[0] === '-'; // negative true if first char is a minus sign
            num = num.replace(/-/g, ''); // remove all minus signs
            num = num.replace(/\.+/g, '.'); // combine any repeated decimals into single decimals

            if (num === '') num = 0;
            else num = parseFloat(num) * (negative ? -1 : 1);

            return num;
        } else {
            return 0;
        }
    }

    static sumOf(arr) {
        let sum = 0;
        if (arr) {
            sum = arr.reduce(function (a, b) {
                if (typeof a === 'string') {
                    a = Number.parseFloat(a);
                }
                if (typeof b === 'string') {
                    b = Number.parseFloat(b);
                }
                return a + b;
            }, 0);
        }
        return sum;
    }

    static formatDate(date) {
        let d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2) month = month;
        if (day.length < 2) day = '0' + day;

        return [month, day, year].join('/');
    }

    static findSelectItemValue(val, items) {
        if (items.length > 0) {
            for (let i = 0; i < items.length; i++) {
                if (items[i].label === val.label) {
                    return true;
                }
            }
        }
        return false;
    }

    static containsObject(obj, key, list) {
        return list.some(elem => elem[key] === obj[key]);
    }

    static isUndefined(val) {
        return val === 'undefined' || val == null || false || val === '' || val === 'null';
    }

    static getAssociationType(value) {
        let associationDescription = '';
        switch (value.toUpperCase()) {
            case 'A':
                associationDescription = 'Authorized Signer';
                break;
            case 'J':
                associationDescription = 'Joint Owner';
                break;
            case 'P':
                associationDescription = 'Primary';
                break;
            case 'C':
                associationDescription = 'Co-Borrower';
                break;
            case 'B':
                associationDescription = 'Beneficiary';
                break;
            default:
                associationDescription = value;
        }
        return associationDescription;
    }

    static filterByAssociation(list, associationType: string) {
        if (list) {
            const arr = [];
            for (const item of list) {
                if (item.associationType.toLowerCase() === associationType.toLowerCase()) {
                    arr.push(item);
                }
            }
            return arr;
        }
        return list;
    }

    static uniqueByAccountNumber(origArr) {
        let newArr = [],
            origLen = origArr.length,
            found,
            x,
            y;

        for (x = 0; x < origLen; x++) {
            found = undefined;
            for (y = 0; y < newArr.length; y++) {
                if (origArr[x].accountNumber === newArr[y].accountNumber) {
                    found = true;
                    break;
                }
            }
            if (!found) {
                newArr.push(origArr[x]);
            }
        }
        return newArr;
    }

    static focus(id, timer = 0) {
        setTimeout(() => {
            const focusId = document.getElementById(id);
            if (focusId) {
                focusId.focus();
            }
        }, timer);
    }

    static isNumeric(val) {
        if (typeof val === 'string') {
            return Number.parseFloat(val);
        }
        return val;
    }

    static filterOpCodesByTranCode(opCodes, tranCode) {
        const tranCodeString = tranCode.toString();
        const arr = [];
        opCodes.forEach(opCode => {
            for (let i = 1; i <= 10; i++) {
                if (i === 1 && opCode['validTranCode' + i] === '0') {
                    arr.push(opCode);
                }

                if (opCode['validTranCode' + i] === tranCodeString) {
                    arr.push(opCode);
                }
            }
        });

        return arr;
    }

    static publicGetTranCodeListFromOpCode(opCode: any): Array<string> {
        const arr = [];
        for (let i = 1; i <= 10; i++) {
            if (opCode && opCode['validTranCode' + i]) {
                arr.push(opCode['validTranCode' + i]);
            }
        }
        return arr;
    }

    static filterOpCodes(codes, type) {
        if (codes) {
            const t = [];
            const d = [];
            const w = [];
            const p = [];
            const c = [];
            codes.forEach(code => {
                for (let i = 1; i <= 10; i++) {
                    if (code['validTranCode' + i] === 0) {
                        if (code['validTranCode1'] === 0) {
                            t.push(code);
                            d.push(code);
                            w.push(code);
                            p.push(code);
                            c.push(code);
                        }
                        break;
                    }
                    switch (code['validTranCode' + i]) {
                        case '2':
                        case '02':
                        case '92':
                            if (!~d.indexOf(code)) {
                                d.push(code);
                            }
                            break;
                        case '3':
                        case '03':
                        case '4':
                        case '04':
                        case '5':
                        case '05':
                        case '90':
                        case '91':
                            if (!~w.indexOf(code)) {
                                w.push(code);
                            }
                            break;
                        case '6':
                        case '06':
                        case '7':
                        case '07':
                        case '9':
                        case '09':
                            if (!~p.indexOf(code)) {
                                p.push(code);
                            }
                            break;
                        default:
                            if (!~t.indexOf(code)) {
                                t.push(code);
                            }
                            if (!~c.indexOf(code)) {
                                c.push(code);
                            }
                            break;
                    }
                }
            });

            switch (type) {
                case 'd':
                    return d;
                case 't':
                    return t;
                case 'p':
                    return p;
                case 'c':
                    return c;
                case 'wcash':
                case 'wcheck':
                    return w;
            }
        }
    }

    static stripNonNumeric(value: string): number | undefined {
        const match = value.match(/\d+(\.\d+)?/);
        if (match) {
            return Number.parseFloat(match[0]);
        }
    }

    static replaceAll(val1: string, val2: string, string: string) {
        if (val1) {
            val1 = this.escapeRegExp(val1);
            return string.replace(new RegExp(val1, 'g'), val2);
        }
    }

    static replaceAllRegExp(val1: string, val2: string, string: string) {
        if (val1) {
            return string.replace(new RegExp(val1, 'g'), val2);
        }
    }

    static escapeRegExp(str: string) {
        return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }

    static isClosed(recordCode: string): boolean {
        return recordCode === '2' || recordCode === '3';
    }

    static stripTIN(tin: string): string {
        return tin.replace(/(^0+)|-/g, '');
    }

    // Params: Two objects of the same type
    // Returns: An array of differences between the objects, including keys, the value of the first object, and the value of the second object.
    static compareObjects(obj1: object, obj2: object): Array<{ key: string; val1: any; val2: any }> {
        const arr: Array<{ key: string; val1: any; val2: any }> = [];
        for (const i in obj2) {
            if (!obj1.hasOwnProperty(i) || obj2[i] !== obj1[i]) {
                arr.push({key: i, val1: obj1[i], val2: obj2[i]});
            }
        }
        return arr;
    }

    /**
     * Like [Array#includes]{@link Array.prototype.includes} but to use with a custom predicate function for determining equality
     */
    static includes<T>(
        array: T[],
        predicate: (t: T, searchElement: T) => boolean,
        searchElement: T,
        fromIndex = 0,
    ): boolean {
        for (let i = fromIndex; i < array.length; i++) {
            if (predicate(array[i], searchElement)) return true;
        }
        return false;
    }

    static onRightClick(event) {
        event.preventDefault();
    }

    static unsubscribe(subscription: Subscription | null): void {
        if (subscription) {
            subscription.unsubscribe();
        }
    }

    static compare(a: any, b: any): number {
        if (a > b) return 1;
        if (a < b) return -1;
        return 0;
    }

    static timestamp(date: Date): string {
        const value = new Date().getTime() - new Date().getTimezoneOffset() * 60000;
        return new Date(value).toISOString();
    }

    // gets a value out of an object (that may be nested) where the key may be dotted, e.g. 'user.name.first'
    static getNestedValue(obj: object, key: string): any {
        if (!obj || !key || typeof obj !== 'object' || typeof key !== 'string') {
            return undefined;
        }
        const arr = key.split('.');
        for (const subkey of arr) {
            obj = obj[subkey];
        }
        return obj;
    }

    static getAverageOfArray(arr: Array<any>): number {
        return arr.length > 0 ? Math.round(arr?.reduce((a, b) => a + b) / arr.length) : 0;
    }

    /**
     * Groups elements in an array by a key returned from the keyGetter
     * @param list array of elements to be grouped
     * @param keyGetter callback function that returns the key for a value
     * @return a Map with the keys returned from the keyGetter and the values from the array grouped with those keys
     */
    static groupBy<K, V>(list: V[], keyGetter: (value: V) => K): Map<K, V[]> {
        const groupByMap = new Map<K, V[]>();
        list.forEach(item => {
            const key = keyGetter(item);
            const collection = groupByMap.get(key);
            if (!collection) {
                groupByMap.set(key, [item]);
            } else {
                collection.push(item);
            }
        });
        return groupByMap;
    }
}
